import { inject, Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { ITableConfig, ITableConfigStrategy } from '@cinetixx/cinetixx-ui';
import { UserPreferencesService } from '../services/UserPreferencesService';

@Injectable({
  providedIn: 'root'
})
export class TableConfigDatabaseStrategy<T> implements ITableConfigStrategy<T> {

  private readonly _keyPrefix = 'table-config';

  private readonly _userPreferencesService = inject(UserPreferencesService);

  private _cache = new Map<string, ITableConfig<T>>();

  public getConfig(namespace: string): Observable<ITableConfig<T>> {
    if (this._cache.has(namespace)) {
      return of(this._cache.get(namespace));
    }

    return this._userPreferencesService.getPreferenceByKey(this.getKey(namespace)).pipe(
      tap((config) => {
        this._cache.set(namespace, config);
      })
    );
  }

  public saveConfig(namespace: string, config: ITableConfig<T>): Observable<any> {
    return this._userPreferencesService.savePreferences(this.getKey(namespace), config).pipe(
      tap(() => {
        this._cache.set(namespace, config);
      })
    );
  }

  private getKey(namespace: string): string {
    return `${this._keyPrefix}-${namespace}`;
  }
}
